import { appendScriptToHead } from "../utils/utils";
import config from "../constants/config";
import CookieService from "./cookie.service";

const { ENV_SUFIX } = config;

const QA_REQUIRED_ADOBE_LAUNCH_SRC =
  "https://assets.adobedtm.com/7e08552ade3f/1a8047d2b483/launch-08747c23b17b-development.min.js";
const PROD_REQUIRED_ADOBE_LAUNCH_SRC =
  "https://assets.adobedtm.com/7e08552ade3f/1a8047d2b483/launch-f46125d37e44.min.js";

export default class AdobeAnalyticsService {
  static isQaEnvironment(hostname = window.location?.hostname) {
    return (
      hostname === "www.qa.thermofisher.com" ||
      hostname === "qa-identity.thermofisher.com" ||
      hostname === "qa1.thermofisher.cn" ||
      hostname === "www.thermofisher.cn" 
    );
  }

  static getOptInAdobeLaunchSrc() {
    return `//assets.adobedtm.com/launch-${
      process.env[`REACT_APP_ADOBE_LAUNCH${ENV_SUFIX}`]
    }.min.js`;
  }

  static getAdobeLaunchSrc({
    hostname = window.location?.hostname,
    noticePreferences = CookieService.getCookie("notice_preferences"),
  } = {}) {
    if (!noticePreferences || noticePreferences.charAt(0) === "0") {
      return this.isQaEnvironment(hostname)
        ? QA_REQUIRED_ADOBE_LAUNCH_SRC
        : PROD_REQUIRED_ADOBE_LAUNCH_SRC;
    }

    return this.getOptInAdobeLaunchSrc();
  }

  static setUpAdobeAnalytics() {
    const adobeLaunchUrl = this.getAdobeLaunchSrc();

    if (process.env[`REACT_APP_ADOBE_ENABLED${ENV_SUFIX}`] === "true") {
      appendScriptToHead(adobeLaunchUrl, true);
    }
  }

  static configureDigitalData(page) {
    this.setChangePasswordPageData(page);
  }

  static setChangePasswordPageData(page) {
    window.digitalData.setPageType(page);
  }
}
